import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ChangeStatusAlertModal({ alertModal, closeAlertModal, handleChangeStatus, classes }) {
  return (
    <div>
      <Dialog
        disablePortal
        style={{ position: "absolute" }}
        open={alertModal}
        onClose={closeAlertModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Are you sure you want to cancel this project?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className={classes.noButton} onClick={closeAlertModal}>
            No
          </Button>
          <Button className={classes.yesButton} onClick={handleChangeStatus} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
